import { render, staticRenderFns } from "./PQTExtrasView.vue?vue&type=template&id=4a5585ec"
import script from "./PQTExtrasView.vue?vue&type=script&lang=js"
export * from "./PQTExtrasView.vue?vue&type=script&lang=js"
import style0 from "./PQTExtrasView.vue?vue&type=style&index=0&id=4a5585ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports